export const environment = {
  production: true,
  basePath: 'https://ilademo.mi2.in',
  idleTimeEnable: true
};
